function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * AAA IDP Error component
 * 
 */

import * as React from 'react';
import './ErrorMessage.scss';
import { jsx as _jsx } from "react/jsx-runtime";
class ErrorMessage extends React.Component {
  render() {
    let {
      error,
      errorStyle,
      message
    } = this.props;
    if (!error || message.length === 0) {
      return null;
    }
    errorStyle = errorStyle.length > 0 ? ` ${errorStyle}` : '';
    return /*#__PURE__*/_jsx("div", {
      className: `error-message${errorStyle}`,
      children: /*#__PURE__*/_jsx("div", {
        className: "message",
        dangerouslySetInnerHTML: {
          __html: message
        }
      })
    });
  }
}
_defineProperty(ErrorMessage, "defaultProps", {
  message: '',
  error: false,
  errorStyle: ''
});
export default ErrorMessage;